import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const documentService = {
  get: async (search, token) => {
    const response = await https.get(
      `${API_ROUTES.DOCUMENT.GET}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_id: async (document_id, token) => {
    const response = await https.get(
      `${API_ROUTES.DOCUMENT.GET_BY_ID}/${document_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
